export const sanitizeNumber = (number) => {
    const digitsOnly = number.replace(/[^0-9]/g, '');

    return digitsOnly.charAt(0) === '1' ? digitsOnly : `1${digitsOnly}`;
};
